/**
 * @hook useNavBar
 * @title 네비게이션 바 컨트롤
 * @description
 * @properties
 * @returns
 * @author 2037688
 * @history
 *   - [2026-06-10] 초기 작성
 */

import { useCallback } from 'react';
import {
  Channel,
  EventType,
  useAppContext,
  useEventBusEmit,
  useWebviewBridge,
} from 'scbk-services';
import { useSession } from 'scbk-shared-module';
import { usePopupStore } from 'scbk-shared-module/modules/GlobalComponents';

export const useNavBar = () => {
  const { getContext } = useAppContext();
  const currentChannel = getContext().channel as Channel;
  const emit = useEventBusEmit();
  const { doNGetMainNavBarStatus, doNGetCurrentWebviewStatus } = useWebviewBridge();
  const { isLogin } = useSession();

  const navBarControl = useCallback(
    async (showNavBar?: boolean, trigger?: boolean) => {
      //모바일뱅킹이 아닌경우
      if (currentChannel !== Channel.MB) {
        return;
      }

      // sessionStorage.setItem('savedNavBarStatus', '');

      console.log('## navBarControl start', new Error('navBarControl'));

      //----------------------------------------------
      //현재웹뷰가 활성화된 웹뷰 여부를 확인, 하단 네비바를 노출여부를 결정한다.
      //----------------------------------------------
      const res = await doNGetCurrentWebviewStatus();
      const { isTop } = res;

      console.log('# CSD navbar isTop', isTop, location.href);

      if (!isTop) {
        return;
      }

      sessionStorage.setItem('savedNavBarStatus', showNavBar ? 'Y' : '');
      let eventType = showNavBar ? EventType.ShowNavbar : EventType.HideNavbar;

      const entry = usePopupStore.getState().entry;

      console.log('### popup entry : ', entry);

      if (
        (Object.keys(entry).length !== 0 &&
          Object.values(entry).some((item) => item?.visible === true)) ||
        trigger
      ) {
        const savedNavBarStatus = sessionStorage.getItem('savedNavBarStatus');
        if (!savedNavBarStatus) {
          // 현재 상태
          const currentNavBarStatus = await doNGetMainNavBarStatus();
          sessionStorage.setItem('savedNavBarStatus', currentNavBarStatus === '1' ? 'Y' : 'N');
        }

        eventType = EventType.HideNavbar;
      } else if (!isLogin()) {
        eventType = EventType.HideNavbar;

        // storage 상태 복구
        sessionStorage.setItem('savedNavBarStatus', '');
      } else {
        const savedNavBarStatus = sessionStorage.getItem('savedNavBarStatus');
        // 팝업이 다꺼지면 저장된 네이바 상태를 확인하고 Y 면 show, N 이면 HIDE
        if (savedNavBarStatus === 'Y') {
          eventType = EventType.ShowNavbar;
        }

        if (savedNavBarStatus === 'N') {
          eventType = EventType.HideNavbar;
        }

        // storage 상태 복구
        sessionStorage.setItem('savedNavBarStatus', '');
      }

      console.log('### popup eventType : ', eventType);

      emit(eventType);
    },
    [currentChannel],
  );

  return {
    navBarControl,
  };
};
